export default __webpack_public_path__ + "images/referenzen/werbespot/barclaycard_tvc-eritage.mp4";